// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"87a5f1c6","453":"ce913a76","455":"5bf63974"}[chunkId] + ".chunk.js";
};